// Placeholder pages for the top-level sidebar destinations.
// These are outside the 9-tab strip but part of the shell walkthrough.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';

export function MyWorkStub(): ReactNode {
  return (
    <TabPlaceholder
      tabName="My Work"
      wiringNotes="Rep queue: prioritized list of the rep's assigned contacts. Reads from services/customer-ownership + services/sales-interactions."
    />
  );
}

export function MyCreditStub(): ReactNode {
  return (
    <TabPlaceholder
      tabName="My Credit"
      wiringNotes="Rep credit and commission explanation from services/credit-explanation."
    />
  );
}

export function ManagerStub(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Manager"
      wiringNotes="Manager view: operational alerts, rep availability, evidence review. Enterprise-only per project_100x_equine_crm_build."
    />
  );
}

export function CoachingStub(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Coaching"
      wiringNotes="Coaching analytics feed from services/coaching-analytics."
    />
  );
}

export function ContactRootStub(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Workspace root"
      wiringNotes="A contact route with no tab selected redirects to /current. If you see this page the redirect is missing."
    />
  );
}
